import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsx as r } from "react/jsx-runtime";
import { Fonts as o } from "@vds-core/typography";
import { calculateRem as t } from "@vds-core/utilities";
import e from "styled-components";
import i from "./InputText.js";
var n = {
    errorMarginLeft: t(-1)
  },
  f = e.div.withConfig({
    displayName: "StyleCheckboxError",
    componentId: "VDS__sc-ftcb6p-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  margin-top: 0;\n  left: ", ";\n"])), function (_ref) {
    var r = _ref.$errorMarginLeft;
    return r;
  }),
  c = function c(t) {
    var e = t.errorText,
      n = t.color,
      c = t.errorMarginLeft;
    return r(f, {
      $errorMarginLeft: c,
      children: r(i, {
        color: n,
        fontFamily: o.VerizonNHGeTX,
        children: e
      })
    });
  };
c.defaultProps = n;
export { c as default };